import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=e4c439ec&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=ts"
export * from "./SidebarItem.vue?vue&type=script&lang=ts"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=e4c439ec&prod&lang=scss"
import style1 from "./SidebarItem.vue?vue&type=style&index=1&id=e4c439ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c439ec",
  null
  
)

export default component.exports